/**
 * PlayCanvas configurator change utilities.
 * Uses window.configurator.setConfig() to apply material changes.
 */

/**
 * Set a material on the PlayCanvas configurator.
 *
 * @param {Object} props
 * @param {string} props.propertyKey — PlayCanvas property key (e.g. 'railing', 'flooring')
 * @param {string} props.materialName — material name (e.g. 'Midnight', 'Driftwood')
 */
export const setPlayCanvasConfiguration = async (props) => {
  const { propertyKey, materialName } = props;

  if (!window.configurator) {
    console.warn('[PlayCanvas] configurator not ready');
    return;
  }

  console.log('[PlayCanvas] setConfig', { [propertyKey]: materialName });

  try {
    await window.configurator.setConfig({ [propertyKey]: materialName });
  } catch (err) {
    console.error('[PlayCanvas] setConfig failed:', err);
  }
};

/**
 * Legacy wrapper: matches the old setConfiguration({itemAttribute, value, name}) signature
 * but routes through PlayCanvas API. Used by SettingsGroup and MobileConfig.
 *
 * @param {Object} props
 * @param {string} props.itemAttribute — the setting.name (human label like "Railing")
 * @param {string} props.name — material display name (e.g. "Midnight")
 * @param {string} props.propertyKey — PlayCanvas key (e.g. "railing")
 */
export const setConfiguration = (props) => {
  const { propertyKey, materialName, name } = props;
  const value = materialName || name;

  if (!propertyKey || !value) {
    console.warn('[PlayCanvas] setConfiguration: missing propertyKey or materialName/name', props);
    return;
  }

  setPlayCanvasConfiguration({ propertyKey, materialName: value });
};

/**
 * Create a snapshot of the current PlayCanvas canvas as base64 image.
 */
export const createSnapshot = async () => {
  const canvas = document.getElementById('application-canvas');
  if (!canvas) return null;
  try {
    return canvas.toDataURL('image/png');
  } catch (err) {
    console.error('[PlayCanvas] snapshot failed:', err);
    return null;
  }
};
